export default __webpack_public_path__ + "static/media/feature-mngd-services-2.2106a6e3.png";